/**
 * Thin wrapper around flatpickr datetime picker
 * https://flatpickr.js.org/
 */
import Flatpickr from 'stimulus-flatpickr'

export default class extends Flatpickr {
  connect() {
    const mode = this.element.dataset.flatpickrMode || 'single'
    const baseConfig = {
      altInput: true,
    }

    if (mode === 'range') {
      this.config = {
        ...baseConfig,
        mode: 'range',
        enableTime: false,
        dateFormat: 'Y-m-d',
        onClose: (selectedDates) => {
          this.handleRangeChange(selectedDates)
        }
      }
    } else {
      this.config = baseConfig
    }

    super.connect()
  }

  handleRangeChange(selectedDates) {
    // If we have two dates, populate hidden fields
    if (selectedDates.length === 2) {
      const startDate = this.formatDate(selectedDates[0])
      const endDate = this.formatDate(selectedDates[1])

      // Get the field name prefix (e.g., 'created_at', 'updated_at')
      const fieldPrefix = this.element.dataset.dateFieldPrefix

      if (fieldPrefix) {
        // Find and populate hidden fields
        const form = this.element.closest('form')
        const gteqField = form?.querySelector(`input[name="q[${fieldPrefix}_gteq]"]`)
        const lteqField = form?.querySelector(`input[name="q[${fieldPrefix}_lteq]"]`)

        if (gteqField) gteqField.value = startDate
        if (lteqField) lteqField.value = endDate

        // Trigger form submission via Stimulus form controller
        if (form) {
          const formController = this.application.getControllerForElementAndIdentifier(form, 'form')
          if (formController && formController.submit) {
            formController.submit()
          }
        }
      }
    }
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}
